import React from 'react';

export default ({ color = '#525979', size = 17 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4583 15.5837H3.54163C2.36802 15.5837 1.41663 14.6323 1.41663 13.4587V2.12533C1.41663 1.73413 1.73376 1.41699 2.12496 1.41699H12.0416C12.4328 1.41699 12.75 1.73413 12.75 2.12533V10.6253H15.5833V13.4587C15.5833 14.6323 14.6319 15.5837 13.4583 15.5837ZM12.75 12.042V13.4587C12.75 13.8499 13.0671 14.167 13.4583 14.167C13.8495 14.167 14.1666 13.8499 14.1666 13.4587V12.042H12.75ZM11.3333 14.167V2.83366H2.83329V13.4587C2.83329 13.8499 3.15043 14.167 3.54163 14.167H11.3333ZM4.24996 4.95866H9.91663V6.37533H4.24996V4.95866ZM4.24996 7.79199H9.91663V9.20866H4.24996V7.79199ZM4.24996 10.6253H7.79163V12.042H4.24996V10.6253Z"
      fill={color}
    />
  </svg>
);
